<template>
	<div class="o-page-login" data-component="passwordchange"
        :data-component-name="$options.name"
    >
		<div class="o-row">
            <div class="o-col -login-welcome">
                <div class="o-page-login__content">
                    <div class="o-page-login__header">
                        <SvgIcon name="logo" class="o-page-login__logo" />
                    </div>
                    <!-- <div class="o-page-login__sub-header">
                                        Console d'affectation
                                    </div> -->
                    <h1 class="o-page-login__title">
                        Gestionnaire <br>haute performance <br>des <strong>affectations</strong>
                    </h1>
                    <p class="o-page-login__text">
                        Optimisez et gérez efficacement les ressources humaines et matérielles nécessaires à la
                        réalisation de vos projets grâce à cette application web. Connectez-vous pour accéder à votre
                        gestionnaire ou <a href="mailto:info@monriff.ca?subject=Demande d'informations">contactez-nous</a> afin d’en
                        savoir plus.
                    </p>
                    <a href="https://monriff.ca" target="_blank" class="o-button -outline -ico-right o-page-login__button">En savoir
                        plus
                        <SvgIcon name="external-link" />
                    </a>
                </div>
            </div>
			<div class="o-col -login">
				<div class="o-page-connect">
					<h2 class="o-page-connect__title -reset_password">Changement de mot de passe</h2>
                    <div class="o-page-connect__msg">Votre mot de passe est arrivé à échéance. Vous devez entrer un nouveau mot de passe.</div>
					<q-form @submit.prevent="changePassword" ref="changePasswordForm">
						<div class="o-form__item o-page-connect__input">
                            <Input
                                input-class="o-page-connect__input"
                                v-model="password"
                                ref="currentPassword"
                                placeholder=""
                                autocomplete="current-password"
                                type="password"
                                label="Ancien mot de passe"
                                required=true
                                error-message="Ce champ est requis"
                                :dense="true"
								:borderless="true"
                                :filled="false"
                            />
						</div>
						<div class="o-form__item o-page-connect__input">
                            <Input
                                v-model="newPassword"
                                ref="newPassword"
                                placeholder=""
                                type="password"
                                autocomplete="new-password"
                                label="Nouveau mot de passe"
                                required=true
                                :error="newPasswordValid"
                                :error-message="newPasswordValidMSG"
                                @input="newPassword=$event"
                                :dense="true"
								:borderless="true"
                                :filled="false"
                            />
						</div>
						<div class="o-form__item o-page-connect__input">
                            <Input
                                v-model="newPasswordConfirm"
                                ref="newPasswordConfirm"
                                placeholder=""
                                autocomplete="new-password"
                                type="password"
                                label="Confirmer nouveau mot de passe"
                                required=true
                                :error="newPasswordConfirmValid"
                                error-message="Le mot de passe ne correspond pas au nouveau mot de passe"
                                @input="newPasswordConfirmValid=isSame($event, 'newPassword')"
                                :dense="true"
								:borderless="true"
                                :filled="false"
                            />
						</div>
                        <div class="o-page-connect__submit q-mt-md">
                            <div class="o-page-connect__forgotpw">
                                <router-link :to="{ name: 'login' }">Page de connexion</router-link>
                            </div>
                            <div class="o-page-connect__button">
                                <button class="o-button -ico-right" :loading="loading" color="primary">Connexion<SvgIcon name="arrow-right" /></button>
                            </div>
                        </div>
					</q-form>
					<!-- <div class="o-page-connect__createaccount">
						Vous n'avez pas de compte? <router-link :to="{ name: 'register' }">S'enregistrer</router-link>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { mapActions } from 'vuex'
	import { CHANGEPASSWORD } from '@/graphql/user/mutations'

    export default {
        data() {
            return {
                appName: process.env.VUE_APP_NAME || 'worky.',
                loading: false,
                password: null,
                newPassword: null,
                newPasswordConfirm: null,
                newPasswordValid: false,
                newPasswordValidMSG: 'Ce champ est requis',
                newPasswordConfirmValid: false,
                alert: false 
            }
        },
        async created() {
            // await this.$store.dispatch('auth/logout')
            // let me = this.$store.getters['auth/me']
        },

        methods: {
			...mapActions({'setMyProfile': 'auth/setMyProfile'}),
			async changePassword() {
                let validation=await this.$refs.changePasswordForm.validate()
                if(!validation){
                    this.$q.notify({type: 'negative', message: "Informations non savegardées", caption: "Certains champs requis n'ont pas été remplis"});
                    return false;
                }

                this.$apollo.mutate({
                    mutation: CHANGEPASSWORD,
                    variables: { 
                        currentPassword: this.password,
                        newPassword: this.newPassword,
                        newPasswordConfirm: this.newPasswordConfirm,
                    },
                }).then(() => {
                    this.$router.push('login')
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: e.message, caption: 'Le changement de mot de passe n\'a pas été appliqué.'});
                })

			},
            isDifferent(needle, haystack){
                if(needle=='' || !this.$refs[haystack]) return false;
                return needle == this.$refs[haystack].value
            },
            isSame(needle, haystack){
                if(needle=='' || !this.$refs[haystack]) return false;
                return needle != this.$refs[haystack].value
            },
        },

        watch:{
            newPassword: function(){
                let complexityError=false;
                this.newPasswordValid=false;

                if(!this.newPassword || this.newPassword==""){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Ce champ est requis.";
                    return;
                }
                if(this.newPassword==this.password){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Le nouveau mot de passe doit être différent du mot de passe précédent.";
                    return;
                }

                if( this.newPassword.length < 8 ){
                    complexityError=true;
                } 
                if( ! /\d/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[a-z]/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[A-Z]/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[!@#$%^&*)(+=._-]/.test(this.newPassword) ) complexityError=true;

                if(complexityError){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Le nouveau mot de passe doit contenir au minimum 8 caractères et au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.";
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "@/scss/views/Login.scss";
</style>
